import { render } from "./AddReglementGroupePage.vue?vue&type=template&id=1df7f2e0&ts=true"
import script from "./AddReglementGroupePage.vue?vue&type=script&lang=ts"
export * from "./AddReglementGroupePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__